import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`You ever see something and think to yourself:`}</p>
    <blockquote>
      <p parentName="blockquote">{`"Wow! That's really neat."`}</p>
    </blockquote>
    <p>{`Yeah, that. That's what we strive for. We're working on some cool things and we can't wait share them with you. We're pretty sure you'll agree they're really neat.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      